class Sand{
    constructor(){
        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }
    
    start(page){
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
    }
    
    reset(page){
        this.pageActive[page] = false;
        this.context.removeClass('animate-in animate-1 animate-2');
        this.context.addClass('animate-out');
        this.context.find('.active').removeClass('active');
        
        setTimeout(() =>{
            if(!this.pageActive[page]){
                this.videoBg[page] && this.videoBg[page].stop();
            }
        }, 1000);
    }
    
    sand1(){
        this.context = $('.section-page__sand');
        this.context.addClass('animate-in animate-1');
        
        this.context.find('.obj3-ch1').addClass('active');
        this.context.find('.obj3-txt1').addClass('active');
        
        this.playBg('sand1');
    }
    
    sand2(){
        this.context = $('.section-page__sand');
        this.context.addClass('animate-in animate-2');
        
        this.context.find('.obj3-ch2').addClass('active');
        this.context.find('.obj3-txt2').addClass('active');
        
        this.playBg('sand2');
    }
    
    setBg(){
        this.videoBg.sand1 = new nc.ui.Player({
            selector: '#bg-video-sand1',
            videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/03_UPDATE_LOW.mp4',
            mute: true,
            autoPlay: false,
            loop: true
        });
        this.videoBg.sand2 = new nc.ui.Player({
            selector: '#bg-video-sand2',
            videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/update/201709/04_UPDATE_LOW.mp4',
            mute: true,
            autoPlay: false,
            loop: true
        });
    }
    
    playBg(id){
        if(this.videoBgReady[id]){
            this.videoBg[id].play();
            return;
        }
        
        let checkReady = setInterval(() =>{
            this.videoBgReady[id] = this.videoBg[id].player.state.isReady;
            if(this.videoBgReady[id]){
                this.videoBg[id].play();
                clearInterval(checkReady);
            }
        }, 100);
    }
}

export default Sand;


// WEBPACK FOOTER //
// ./history/2017/170913_taecheon/_src/js/page/sand.js